export default __webpack_public_path__ + "static/1-post-145fe311e561046cd76df79548b5a941.png";